/**
 * Root-relative paths to optimized WebP files in `public/img/`.
 * Regenerate with `npm run optimize:images` after replacing source PNGs.
 */
export const SPECIES_GATE_HERO = '/img/dog-family.webp';

export const SPECIES_GATE_DOG_THUMB = '/img/labrador.webp';

export const SPECIES_GATE_CAT_THUMB = '/img/orange-cat.webp';
